import { EcommerceCartProps } from '@aytm/app/swidget/base/questions/Ecommerce/types.ts'
import style from '@aytm/app/swidget/base/questions/Ecommerce/style.module.scss'
import eStyles from '../ecommerce.module.scss'
import { getMediumAssetPath } from '@aytm/lib/common/assets.ts'
import React from 'react'
import EmptyImage from './empty.svg'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'
import { formatPriceWithLocale } from '@aytm/app/swidget/base/questions/Ecommerce/functions.ts'
import { Dropdown } from 'primereact/dropdown'
import useTimeline from '@aytm/app/swidget/base/modules/timeline/useTimeline'

const Ecommerce = ({ response, schema, totals, onUpdateResponse }: EcommerceCartProps) => {
  const { t, languageTag } = useSurveyLocale()
  const findability = 'find' == schema.mode_type || (1 == schema.max_cart_size && !schema.shopping_cart)

  const maxQty = findability ? null : schema.max_qty_per_product
  const maxCartSize = findability ? null : schema.max_cart_size
  const maxMoney = findability ? null : schema.max_money_spent
  const options = [...Array(100).keys()]
  const timeline = useTimeline()

  const onCartChange = (i: number, v: number) => {
    response.answers[i].v = v
    onUpdateResponse(response)
    timeline.log(
      v
        ? {
            type: 'edit_in_cart',
            ref: response.answers[i].id,
            target: v.toString()
          }
        : { type: 'delete_from_cart', ref: response.answers[i].id }
    )
  }

  const onCartSelect = (i: number) => {
    response.answers[i].selected = true
    onUpdateResponse(response)
  }

  return (
    <div className={style.cart}>
      {response.answers.filter(r => r.v > 0).length ? (
        response.answers.map((r, ri) => {
          const rOptions = options
            .filter(
              v =>
                (!maxQty || v + 1 <= maxQty) &&
                (!maxCartSize || v + 1 + totals[0] <= maxCartSize + r.v) &&
                (!maxMoney || (v + 1) * r.price + totals[1] <= maxMoney + r.price * r.v)
            )
            .map(i => {
              return { id: i + 1, label: (i + 1).toString(), value: i + 1 }
            })
          return (
            <>
              {r.v > 0 ? (
                <div className={style.cartRow} key={ri}>
                  <div className={style.imageBlock}>
                    <img
                      data-testid="SW-SH-CartProduct-Image"
                      className={style.image}
                      alt={
                        schema.answers[ri].image && schema.answers[ri].image.original_url
                          ? schema.answers[ri].image?.alt_text || t('questions', 'img', 'noAlt')
                          : ''
                      }
                      src={
                        schema.answers[ri].image && schema.answers[ri].image.original_url
                          ? `${getMediumAssetPath(schema.answers[ri].image, 'transparent')}`
                          : `/images/widget/sh/emptyBottle.png`
                      }
                      onClick={() => onCartSelect(ri)}
                    />
                  </div>
                  <div className={style.block}>
                    <div className={style.description} data-testid="SW-SH-CartProduct-Description">
                      <span
                        data-testid="SW-SH-CartProduct-Header"
                        className={style.header}
                        onClick={() => onCartSelect(ri)}
                        dangerouslySetInnerHTML={{ __html: schema.answers[ri].text }}
                      />
                      <div className={eStyles.buttons} data-testid="SW-SH-Item-Buttons">
                        <Dropdown
                          options={rOptions}
                          confirmKeyboardSelect={true}
                          onChange={v => onCartChange(ri, v.value as number)}
                          value={r.v}
                          disabled={!rOptions.length}
                          placeholder={r.v.toString()}
                        />
                        <div
                          data-testid="SW-SH-CartProduct-Button-Delete"
                          onClick={() => onCartChange(ri, 0)}
                          className={eStyles.delete}
                        >
                          {t('questions', 'ec', 'deleteFromCart')}
                        </div>
                      </div>
                    </div>
                    <div className={style.priceBlock}>
                      {!schema.hide_price && (
                        <div
                          className={eStyles.price}
                          data-testid="SW-SH-CartProduct-Price"
                          dangerouslySetInnerHTML={{
                            __html: formatPriceWithLocale(
                              (schema.answers[ri].discounted_price
                                ? schema.answers[ri].discounted_price
                                : schema.answers[ri].price) * r.v,
                              schema.price_mask,
                              languageTag,
                              true
                            )
                          }}
                        />
                      )}
                      {schema.answers[ri].price > schema.answers[ri].discounted_price &&
                      schema.answers[ri].discounted_price &&
                      !schema.hide_price ? (
                        <div
                          className={eStyles.discountedPrice}
                          data-testid="SW-SH-Item-DPrice"
                          dangerouslySetInnerHTML={{
                            __html:
                              formatPriceWithLocale(schema.answers[ri].price, schema.price_mask, languageTag, true) +
                              (r.v > 1 ? ' ' + t('questions', 'ec', 'each') : '')
                          }}
                        />
                      ) : (
                        ''
                      )}
                      {r.v > 1 && !schema.hide_price && (
                        <div
                          className={eStyles.small}
                          dangerouslySetInnerHTML={{
                            __html:
                              formatPriceWithLocale(
                                schema.answers[ri].discounted_price || schema.answers[ri].price,
                                schema.price_mask,
                                languageTag
                              ) +
                              ' ' +
                              t('questions', 'ec', 'each')
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div key={ri} />
              )}
            </>
          )
        })
      ) : (
        <div className={style.empty} data-testid="SW-SH-CartEmpty">
          <img src={EmptyImage} alt="" role="presentation" />
          <div>{t('questions', 'ec', 'emptyCard')}</div>
        </div>
      )}
    </div>
  )
}

export default Ecommerce
